import { useEffect, useState, useRef } from 'react'
import userProductService from '../services/userProductService'
import { VEHICLE_TYPE } from '../constants/global'
import { IS_TAX_CDS_MODE } from '../constants/appMode'
// export const SERVICE_TYPE_FREE = 1;
export const SERVICE_TYPE_ZALO = 2
export const SERVICE_TYPE_SMS = 3
export const SERVICE_TYPE_EMAIL = 4
export const SERVICE_NOTIFY_CRIMINAL = 9
export const SERVICE_TAX_CDS = 10

const EMAIL_REGEX = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/

function isValidEmail(email) {
  if (typeof email !== 'string') return false
  const s = email.trim()
  if (!s) return false
  return EMAIL_REGEX.test(s)
}

const useAutomatedTrafficFineNotificationServices = () => {
  const [services, setServices] = useState([])
  const [loadingServices, setLoadingServices] = useState(false)
  const [detailService, setDetailService] = useState(null)
  const hasFetchedRef = useRef(false)

  const [email, setEmail] = useState('')
  const [errorEmail, setErrorEmail] = useState('')
  const [selectedServiceEmailToCheck, setSelectedServiceEmailToCheck] = useState(null)

  const servicesByCategory = {
    // [SERVICE_TYPE_FREE]: [],
    [SERVICE_TYPE_ZALO]: [],
    [SERVICE_TYPE_SMS]: [],
    [SERVICE_TYPE_EMAIL]: [],
    [SERVICE_TAX_CDS]: [],
    OTO: [], // Ô tô (vehicleType: 1)
    XEMAY: [], // Xe máy (vehicleType: 30)
    TAX_CDS: [],
    TAX_CDS_FREELANCE: [],
    TAX_CDS_SME: [],
    TAX_CDS_OFFICE: []
  }

  const selectedServices = services.filter((s) => s.isSelected)
  const isChoosed = selectedServices.length > 0
  const selectedEmailService = selectedServices.find((s) => s.productCategory === SERVICE_TYPE_EMAIL)
  const isEmailValid = isValidEmail(email)
  const safeParseJson = (value) => {
  if (!value) return {}
  if (typeof value === 'object') return value

  try {
    return JSON.parse(value)
  } catch {
    return {}
  }
}
  services.forEach((sv) => {
    if (sv?.productCategory === SERVICE_TAX_CDS) {
      const optionalInfo = safeParseJson(sv?.productOptionalInfo)
      const packageGroup = optionalInfo?.packageGroup

      servicesByCategory[SERVICE_TAX_CDS] = [...servicesByCategory[SERVICE_TAX_CDS], sv]
      servicesByCategory.TAX_CDS = [...servicesByCategory.TAX_CDS, sv]

      if (packageGroup === 'FREELANCE') {
        servicesByCategory.TAX_CDS_FREELANCE = [...servicesByCategory.TAX_CDS_FREELANCE, sv]
      } else if (packageGroup === 'SME') {
        servicesByCategory.TAX_CDS_SME = [...servicesByCategory.TAX_CDS_SME, sv]
      } else if (packageGroup === 'OFFICE') {
        servicesByCategory.TAX_CDS_OFFICE = [...servicesByCategory.TAX_CDS_OFFICE, sv]
      }
    }
    // Filter by những gói giống của Viettel Money
    else if (sv?.productCategory === SERVICE_NOTIFY_CRIMINAL && sv?.vehicleType === VEHICLE_TYPE.CAR) {
      servicesByCategory.OTO = [...servicesByCategory.OTO, sv]
    } else if (sv?.productCategory === SERVICE_NOTIFY_CRIMINAL && sv?.vehicleType === VEHICLE_TYPE.MOTOBIKE) {
      servicesByCategory.XEMAY = [...servicesByCategory.XEMAY, sv]
    } else if (sv?.productCategory === SERVICE_TYPE_ZALO) {
      servicesByCategory[SERVICE_TYPE_ZALO] = [...servicesByCategory[SERVICE_TYPE_ZALO], sv]
    } else if (sv?.productCategory === SERVICE_TYPE_SMS) {
      servicesByCategory[SERVICE_TYPE_SMS] = [...servicesByCategory[SERVICE_TYPE_SMS], sv]
    } else if (sv?.productCategory === SERVICE_TYPE_EMAIL) {
      servicesByCategory[SERVICE_TYPE_EMAIL] = [...servicesByCategory[SERVICE_TYPE_EMAIL], sv]
    }
  })

  const applySelectService = (service) => {
    if (!service) return
    setServices((prev) =>
      prev.map((s) => {
        // Nếu chọn service khác loại (khác vehicleType), bỏ chọn tất cả service cũ
        if (s.vehicleType !== service.vehicleType) {
          return { ...s, isSelected: false }
        }
        // Nếu cùng loại, toggle selection
        if (s.productId === service.productId) {
          return { ...s, isSelected: !s.isSelected }
        }
        // Nếu cùng loại nhưng khác service, bỏ chọn
        return { ...s, isSelected: false }
      })
    )
  }

  const onSelectService = (service) => {
    if (!service) return

    const current = services.find((s) => s.productId === service.productId)
    const isCurrentlySelected = !!current?.isSelected

    if (isCurrentlySelected) {
      applySelectService(service)
      return
    }

    if (service?.productCategory === SERVICE_TYPE_EMAIL) {
      const prevSelected = services.find((s) => s.isSelected)
      const prevIsEmail = prevSelected?.productCategory === SERVICE_TYPE_EMAIL

      if (prevSelected && !prevIsEmail) {
        setSelectedServiceEmailToCheck(service)
        setErrorEmail('')
        return
      }

      if (!isValidEmail(email)) {
        setSelectedServiceEmailToCheck(service)
        setErrorEmail('')
        return
      }
    }

    applySelectService(service)
  }

  const onOpenDetail = (service) => {
    setDetailService(service)
  }

  const onCloseService = () => {
    setDetailService(null)
  }

  useEffect(() => {
    if (hasFetchedRef.current) return
    hasFetchedRef.current = true
    ;(async () => {
      try {
        setLoadingServices(true)

       const [carResponse] = await Promise.all([
        IS_TAX_CDS_MODE
          ? userProductService.getListTaxCdsProductsService({
              filter: {
                productType: 'TAX_CDS_SMART_ASSISTANT'
              },
              skip: 0,
              limit: 200,
              order: {
                key: 'productPriority',
                value: 'asc'
              }
            })
          : userProductService.getListUserProductsService({
              filter: {
                productCategory: [SERVICE_TYPE_ZALO, SERVICE_TYPE_EMAIL, SERVICE_TYPE_SMS, SERVICE_NOTIFY_CRIMINAL]
              }
            })
      ])

        // Gộp data và thêm category
        const carServices = (carResponse.data || []).map((d) => ({
          ...d,
          isSelected: false
        }))

        const allServices = [...carServices]
        setServices(allServices)
      } catch (error) {
        console.error('Error fetching services:', error)
        setServices([])
      } finally {
        setLoadingServices(false)
      }
    })()
  }, [])

  const handleAgreeEmailModal = () => {
    const value = typeof email === 'string' ? email.trim() : ''
    if (!value) {
      setErrorEmail('Vui lòng nhập email')
      return
    }
    if (!isValidEmail(value)) {
      setErrorEmail('Vui lòng nhập email đúng định dạng')
      return
    }

    setEmail(value)
    setErrorEmail('')
    applySelectService(selectedServiceEmailToCheck)
    setSelectedServiceEmailToCheck(null)
  }

  const handleCancelEmailModal = () => {
    setSelectedServiceEmailToCheck(null)
    setErrorEmail('')
  }

  const handleChangeEmailInput = (e) => {
    setEmail(e.target.value)
    setErrorEmail('')
  }

  return {
    setServices,
    onSelectService,
    onOpenDetail,
    onCloseService,
    servicesByCategory,
    selectedServices,
    isChoosed,
    selectedEmailService,
    isEmailValid,
    detailService,
    loadingServices,
    email,
    handleChangeEmailInput,
    errorEmail,
    selectedServiceEmailToCheck,
    handleCancelEmailModal,
    handleAgreeEmailModal,

    taxCdsServices: servicesByCategory.TAX_CDS,
    taxCdsFreelanceServices: servicesByCategory.TAX_CDS_FREELANCE,
    taxCdsSmeServices: servicesByCategory.TAX_CDS_SME,
    taxCdsOfficeServices: servicesByCategory.TAX_CDS_OFFICE
  }
}

export default useAutomatedTrafficFineNotificationServices
